import React from 'react';

import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './switchButtonComponentV2.css';

const SwitchButtonComponentV2 = ({
  switchState = VIDABOO_CONSTANTS.SWITCH_STATES.DISABLED,
  onClick = () => {},
}) => {
  return (
    <div
      className={`et-v2-switch-button-container ${
        switchState === VIDABOO_CONSTANTS.SWITCH_STATES.DISABLED
          ? 'et-v2-switch-button-container-disabled'
          : switchState === VIDABOO_CONSTANTS.SWITCH_STATES.ON
            ? 'et-v2-switch-button-container-on'
            : 'et-v2-switch-button-container-off'
      }`}
      onClick={
        switchState !== VIDABOO_CONSTANTS.SWITCH_STATES.DISABLED
          ? onClick
          : null
      }>
      <div className="et-v2-switch-button-circle" />
    </div>
  );
};

export default SwitchButtonComponentV2;
